import * as Actions from '../../actions/subscription/types';

const initialState = {
  loading: false,
  error: null,

  // get subscription
  subscription: '',
  subscribedPlan: '',
  trialInfo: '',

  // update subscription
  updateSubscriptionLoading: false,
  updateSubscriptionSuccess: '',
  updateSubscriptionError: '',

  plans: [],

  // add ons list
  addOnsList: [],

  // add ons details
  addOnsDetails: '',

  // get add ons (subscribe add ons)
  subscribeAddOnsLoading: false,
  subscribeAddOnsSuccess: '',
  subscribeAddOnsError: '',

  // retry payment

  retryPaymentLoading: false,
  retryPaymentSuccess: '',
  retryPaymentError: '',

  // unsubscribe plan

  unSubPlanLoading: false,
  unSubPlanSuccess: '',
  unSubPlanError: '',

  // end trial

  endTrialLoading: false,
  endTrialSuccess: '',
  endTrialError: '',

  // pay invoice

  payInvoiceLoading: false,
  payInvoiceSuccess: '',
  payInvoiceError: '',

  // upgrade plan

  upgradePlanLoading: false,
  upgradePlanSuccess: '',
  upgradePlanError: '',
};

const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    // get subscription

    case Actions.GET_SUBSCRIPTION_REQUEST:
      return { ...state, loading: true };

    case Actions.GET_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        subscription: action.payload?.data?.currentPlan || '',
        subscribedPlan: action.payload?.data?.subscribedPlan || '',
        plans: action.payload?.data?.featuresData || [],
        trialInfo: action.payload?.data?.SubInfo || '',
        discountedPlanData: action.payload?.data?.discountedPlanData, // paypal
      };

    case Actions.GET_SUBSCRIPTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // update subscription
    case Actions.UPDATE_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        updateSubscriptionLoading: true,
      };

    case Actions.UPDATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        updateSubscriptionLoading: false,
        subscription: action.payload?.currentPlan || '',
        subscribedPlan: action.payload?.subscribedPlan || '',
        plans: action.payload?.featuresData || [],
        updateSubscriptionSuccess: action.payload?.message || 'Success',
        trialInfo: action.payload?.SubInfo || '',
      };

    case Actions.UPDATE_SUBSCRIPTION_FAIL:
      return {
        ...state,
        updateSubscriptionLoading: false,
        updateSubscriptionError: action.payload,
      };

    case Actions.CLEAR_UPDATE_SUBSCRIPTION_STATES:
      return {
        ...state,
        updateSubscriptionLoading: false,
        updateSubscriptionSuccess: '',
        updateSubscriptionError: '',
      };

    // get subscription plans

    case Actions.GET_SUBSCRIPTION_PLANS_REQUEST:
      return { ...state, loading: true };

    case Actions.GET_SUBSCRIPTION_PLANS_SUCCESS:
      const plans = action.payload?.data || [];

      plans?.map((p) => {
        p.label = p.planName;
        p.value = p['_id'];
      });
      return {
        ...state,
        loading: false,
        plans,
      };

    case Actions.GET_SUBSCRIPTION_PLANS_FAIL:
      return { ...state, loading: false, error: action.payload };

    // get add ons

    case Actions.GET_ADD_ONS_LIST_REQUEST:
      return { ...state, loading: true };

    case Actions.GET_ADD_ONS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        addOnsDetails: action.payload?.data?.addOnsDetails || [],
        addOnsList: action.payload?.data?.addOnsList || [],
      };

    case Actions.GET_ADD_ONS_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    // subscribe add ons

    case Actions.SUBSCRIBE_ADD_ONS_REQUEST:
      return { ...state, subscribeAddOnsLoading: true };

    case Actions.SUBSCRIBE_ADD_ONS_SUCCESS:
      return {
        ...state,
        subscribeAddOnsLoading: false,
        subscribeAddOnsSuccess: 'Add-ons added successfully',
        addOnsDetails: action.payload?.data || [],
      };

    case Actions.SUBSCRIBE_ADD_ONS_FAIL:
      return {
        ...state,
        subscribeAddOnsLoading: false,
        subscribeAddOnsError: action.payload || 'Error',
      };

    case Actions.CLEAR_SUBSCRIBE_ADD_ONS_STATES:
      return {
        ...state,
        subscribeAddOnsLoading: false,
        subscribeAddOnsSuccess: '',
        subscribeAddOnsError: '',
      };

    // retry payment

    case Actions.RETRY_PAYMENT_REQUEST:
      return { ...state, retryPaymentLoading: true };

    case Actions.RETRY_PAYMENT_SUCCESS:
      return {
        ...state,
        retryPaymentLoading: false,
        retryPaymentSuccess: action.payload?.message || 'Success',
      };

    case Actions.RETRY_PAYMENT_FAIL:
      return {
        ...state,
        retryPaymentLoading: false,
        retryPaymentError: action.payload || 'Error',
      };

    case Actions.CLEAR_RETRY_PAYMENT_STATES:
      return {
        ...state,
        retryPaymentLoading: false,
        retryPaymentSuccess: '',
        retryPaymentError: '',
      };

    // unsubscribe plan

    case Actions.UNSUBSCRIBE_PLAN_REQUEST:
      return { ...state, unSubPlanLoading: true };

    case Actions.UNSUBSCRIBE_PLAN_SUCCESS:
      return {
        ...state,
        unSubPlanLoading: false,
        unSubPlanSuccess: action.payload?.message || 'Success',
        trialInfo: { ...state.trialInfo, cancel_at_period_end: true },
      };

    case Actions.UNSUBSCRIBE_PLAN_FAIL:
      return {
        ...state,
        unSubPlanLoading: false,
        unSubPlanError: action.payload || 'Error',
      };

    case Actions.CLEAR_UNSUBSCRIBE_PLAN_STATES:
      return {
        ...state,
        unSubPlanLoading: false,
        unSubPlanSuccess: '',
        unSubPlanError: '',
      };

    // end trial

    case Actions.END_TRIAL_REQUEST:
      return { ...state, endTrialLoading: true };

    case Actions.END_TRIAL_SUCCESS:
      return {
        ...state,
        endTrialLoading: false,
        endTrialSuccess: action.payload?.message || 'Success',
        trialInfo: { ...state.trialInfo, status: 'active' },
      };

    case Actions.END_TRIAL_FAIL:
      return {
        ...state,
        endTrialLoading: false,
        endTrialError: action.payload || 'Error',
      };

    case Actions.CLEAR_END_TRIAL_STATES:
      return {
        ...state,
        endTrialLoading: false,
        endTrialSuccess: '',
        endTrialError: '',
      };

    // pay invoice

    case Actions.PAY_INVOICE_REQUEST:
      return { ...state, payInvoiceLoading: true };

    case Actions.PAY_INVOICE_SUCCESS:
      return {
        ...state,
        payInvoiceLoading: false,
        payInvoiceSuccess: action.payload?.message || 'Success',

        subscription: action.payload?.data?.currentPlan || '',
        subscribedPlan: action.payload?.data?.subscribedPlan || '',
        plans: action.payload?.data?.featuresData || [],
        trialInfo: action.payload?.data?.SubInfo || '',
      };

    case Actions.PAY_INVOICE_FAIL:
      return {
        ...state,
        payInvoiceLoading: false,
        payInvoiceError: action.payload || 'Error',
      };

    case Actions.CLEAR_PAY_INVOICE_STATES:
      return {
        ...state,
        payInvoiceLoading: false,
        payInvoiceSuccess: '',
        payInvoiceError: '',
      };

    // upgrade plan

    case Actions.UPGRADE_PLAN_REQUEST:
      return { ...state, upgradePlanLoading: true };

    case Actions.UPGRADE_PLAN_SUCCESS:
      return {
        ...state,
        upgradePlanLoading: false,
        upgradePlanSuccess: action.payload?.message || 'Success',
        subscription: action.payload?.data?.currentPlan || '',
        subscribedPlan: action.payload?.data?.subscribedPlan || '',
        plans: action.payload?.data?.featuresData || [],
        trialInfo: action.payload?.data?.SubInfo || '',
      };

    case Actions.UPGRADE_PLAN_FAIL:
      return {
        ...state,
        upgradePlanLoading: false,
        upgradePlanError: action.payload || 'Error',
      };

    case Actions.CLEAR_UPGRADE_PLAN_STATES:
      return {
        ...state,
        upgradePlanLoading: false,
        upgradePlanSuccess: '',
        upgradePlanError: '',
      };

    default:
      return state;
  }
};

export default subscriptionReducer;
